"use strict";

/**
 * @generated SignedSource<<6fa9e2a2f8ed6cdb7af6d81b9aa0b060>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "VehicleModelSelect_models",
  "selections": [{
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isPopular",
    "storageKey": null
  }, {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "slug",
    "storageKey": null
  }],
  "type": "VehicleModel",
  "abstractKey": null
};
node.hash = "f49c98caaceb24eef94e39b0b8766c89";
export default node;